import { render, staticRenderFns } from "./Functionalities.vue?vue&type=template&id=1fd70e3e&scoped=true"
import script from "./Functionalities.vue?vue&type=script&lang=js"
export * from "./Functionalities.vue?vue&type=script&lang=js"
import style0 from "./Functionalities.vue?vue&type=style&index=0&id=1fd70e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd70e3e",
  null
  
)

export default component.exports